export enum GoalCategory {
  Health = 'Health',
  Fitness = 'Fitness',
  Finance = 'Finance',
  Learning = 'Learning',
  Career = 'Career',
  Relationships = 'Relationships',
  Creativity = 'Creativity',
  Mindfulness = 'Mindfulness',
  Other = 'Other',
}
